export const SET_RECORDING_TO_PLAY = 'SET_RECORDING_TO_PLAY';
export const CLEAR_RECORDING_TO_PLAY = 'CLEAR_RECORDING_TO_PLAY';
